import React from 'react';
import { useDashboardContext } from './DashboardContext';
import { formatMoney } from './helpers';

export const CrossOutletCard: React.FC = () => {
  const { dashboard, selectedOutletId } = useDashboardContext();
  if (selectedOutletId || dashboard.outletPerformance.length === 0) return null;
  return (
    <div className="flex flex-col rounded-[22px] border border-slate-100 bg-white p-5 shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
      <h3 className="mb-3 text-[13px] font-semibold text-slate-900">
        Cross Outlet Performance
      </h3>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[680px] border-collapse text-left text-[11px]">
          <thead>
            <tr className="border-b border-slate-100 text-slate-400">
              <th className="pb-2.5 font-medium">Outlet</th>
              <th className="pb-2.5 text-right font-medium">Net Sale</th>
              <th className="pb-2.5 text-right font-medium">Gross Sale</th>
              <th className="pb-2.5 text-right font-medium">Discounts</th>
              <th className="pb-2.5 text-right font-medium">Bills</th>
              <th className="pb-2.5 text-right font-medium">Avg Bill</th>
            </tr>
          </thead>
          <tbody>
            {dashboard.outletPerformance.map((outlet) => (
              <tr
                key={outlet.outlet_id}
                className="border-b border-slate-50 transition-colors last:border-0 hover:bg-slate-50/50"
              >
                <td className="py-2.5 font-semibold text-slate-900">
                  {outlet.outlet_name}
                </td>
                <td className="py-2.5 text-right font-semibold text-slate-900">
                  {formatMoney(outlet.net_sales)}
                </td>
                <td className="py-2.5 text-right text-slate-500">
                  {formatMoney(outlet.gross_sales)}
                </td>
                <td className="py-2.5 text-right text-slate-500">
                  {formatMoney(outlet.total_discounts)}
                </td>
                <td className="py-2.5 text-right text-slate-500">
                  {outlet.bills_settled}
                </td>
                <td className="py-2.5 text-right text-slate-500">
                  {formatMoney(outlet.average_bill)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
